'use strict';

var _ = require('lodash');
var ConfigurationUserDefinedRefDataFlightTransformerFactory = function ConfigurationUserDefinedRefDataFlightTransformerFactory(DataTransformer) {
  var DTD_ROWS_NUMBER = 366;
  function ConfigurationUserDefinedRefDataFlightTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-user-defined-ref-data-flight-mode';
    this.priority = 1;
  }
  ConfigurationUserDefinedRefDataFlightTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationUserDefinedRefDataFlightTransformer.constructor = ConfigurationUserDefinedRefDataFlightTransformer;
  ConfigurationUserDefinedRefDataFlightTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationUserDefinedRefDataFlightTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationUserDefinedRefDataFlightTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationUserDefinedRefDataFlightTransformer.prototype.transform = function (data) {
    var mappedFlightMetrics = {
      LOAD_FACTOR: 'Load Factor',
      AVAILABILITY: 'Availability',
      CAPACITY: 'Capacity',
      DA_CAPACITY: 'Capacity',
      TOTAL_BOOKINGS: 'Total bookings',
      GROUP_BOOKINGS: 'Group bookings',
      REVENUE: 'Revenue',
      YIELD: 'Yield',
      RASD: 'RASD',
      RPD: 'RPD'
    };
    function changeReferenceMetricToDisplay(referenceMetric) {
      return mappedFlightMetrics[referenceMetric];
    }
    function generateEmptyDtds() {
      return _.times(DTD_ROWS_NUMBER, function (index) {
        return {
          DTD: index,
          AVG: '',
          MAX: '',
          MIN: ''
        };
      });
    }
    function createUrdRow(attributes, status) {
      return {
        airline: attributes.airlineCode,
        flightEntity: attributes.flightEntity,
        flightLeg: _.isUndefined(attributes.origin) || _.isUndefined(attributes.destination) ? '' : attributes.origin + '-' + attributes.destination,
        flightNumber: attributes.number ? parseInt(attributes.number) : attributes.number,
        cabin: attributes.cabinCode,
        season: attributes.season,
        dowGroup: attributes.dayOfWeekGroup,
        referenceMetric: changeReferenceMetricToDisplay(attributes.referenceMetric),
        status: status,
        dtds: []
      };
    }
    if (_.isEmpty(data.domain.hepList)) {
      return [];
    }
    return _.transform(data.domain.hepList, function (result, item) {
      var statusTypes = _.groupBy(item.properties.profile.functionLevelURDs, 'statusType');
      if (Object.keys(statusTypes).length === 0) {
        var emptyRow = createUrdRow(item.attributes, 'DISABLED');
        emptyRow.dtds = generateEmptyDtds();
        result.push(emptyRow);
      }
      _.forEach(_.keys(statusTypes), function (type) {
        var row = createUrdRow(item.attributes, type);
        _.forEach(statusTypes[type], function (level) {
          _.forEach(level.metricValuesCorrespondingToDTD, function (value, index) {
            if (_.isUndefined(row.dtds[index])) {
              row.dtds[index] = {
                DTD: index
              };
            }
            row.dtds[index][level.functionType] = value;
          });
        });
        result.push(row);
      });
    });
  };
  return ConfigurationUserDefinedRefDataFlightTransformer;
};
ConfigurationUserDefinedRefDataFlightTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ConfigurationUserDefinedRefDataFlightTransformerFactory;